import React from 'react';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import VideoPlayButton from "../../common_components/video_play_button/video_play_button";
import ReactPlayer from "react-player";
import "./c78_left_video.scss";

interface C78LeftVideoData {
    video: string;
}

class C78LeftVideo extends TemplateComponent<C78LeftVideoData> {

    state: {
        // true if there is a video and it is playing in the desktop layout
        playing: boolean
    };

    constructor(props: any) {
        super(props);

        this.state = {
            playing: false
        }
    }

    componentRender(data: C78LeftVideoData): React.ReactElement<any> {

        let videoPars: { [key: string]: any } = {
            controls: this.state.playing,
            playing: this.state.playing,
            playsinline: true,
            onPause: () => this.setState({playing: false}),
            url: data.video
        };

        return (
            <div className="c78-left-video">
                <ReactPlayer {...videoPars} className="c78-react-player" playIcon={
                    <div className="play-button-container" onClick={() => this.setState({playing: true})}>
                        <VideoPlayButton startVideo={() => this.setState({playing: true})} />
                    </div>
                }/>
            </div>
        );
    }
}

export default C78LeftVideo;